<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { authStore } from '@/stores/auth.js'

const router = useRouter()
const errorMessage = ref('')
async function choose(tenantId) {
  errorMessage.value = ''
  try {
    await router.replace(await authStore.selectTenant(tenantId))
  } catch (error) {
    errorMessage.value = error?.message || '暂时无法进入该企业空间。'
  }
}
</script>

<template>
  <section class="workspace-placeholder" aria-labelledby="tenant-title">
    <div class="workspace-badge" aria-hidden="true">企</div>
    <p class="eyebrow">ENTERPRISE SPACE</p>
    <h1 id="tenant-title">选择企业空间</h1>
    <p>这里只显示管理员明确授予当前账号的企业，不会自动进入其他企业。</p>
    <div class="tenant-list">
      <button
        v-for="tenant in authStore.state.tenants"
        :key="tenant.id"
        type="button"
        @click="choose(tenant.id)"
      >
        <strong>{{ tenant.name }}</strong>
        <span>{{ ['owner', 'admin'].includes(tenant.role_code) ? '企业管理员' : 'AI 营销项目经理' }}</span>
      </button>
    </div>
    <p v-if="errorMessage" class="form-error" role="alert">{{ errorMessage }}</p>
  </section>
</template>
